// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__3GiD4","tag_type_orange":"styles_tag_type_orange__3WC5y","tag_type_green":"styles_tag_type_green__1NcrN","tag_type_violet":"styles_tag_type_violet__77qtS"};